<template>
<div>
    <v-container v-if="!$store.state.mobile">
        <v-card class="mt-5">
            <div>
                <v-row class="primary-header pa-3 ma-0" align="center">
                    <span style="font-size: 25px">{{ title }}</span>
                </v-row>
                <v-col>
                    <div class="mb-3" style="font-size: 18px">{{ description }}</div>
                    <div class="mb-3" style="font-size: 15px" v-for="text in texts" :key="text">
                        {{ text }}
                    </div>
                </v-col>
            </div>

            <v-divider />

            <div class="pa-3">
                <v-row align="center">
                    <v-col class="headline text-center">
                        <span>{{ results.date }}</span>
                        <v-btn small class="ml-2" color="primary" @click="nextMonth">
                            <v-icon class="mr-2">mdi-play</v-icon>
                            다음 달 진행
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row class="mb-2" align="center">
                    <v-col>
                        <v-btn outlined class="mx-1" color="primary" @click="$refs.assetChartDialog.show(results, docRef)">보고서</v-btn>
                        <v-btn outlined class="mx-1" color="primary" @click="$refs.transactionDialog.show(docRef)">거래 내역</v-btn>
                    </v-col>
                    <v-col class="text-right">
                        <v-btn outlined class="mx-1" color="secondary" @click="sponsor">개발자 후원하기</v-btn>
                    </v-col>
                </v-row>
                <v-card>
                    <div>
                        <v-row class="pa-4 mx-0" align="center">
                            <span style="font-size: 20px; font-weight: bold">총 자산 현황</span>
                            <v-spacer />
                            <span class="px-3" style="font-size: 16px">{{ commaFormat(Math.floor(totalAsset)) }} 원</span>
                            <span :style="{color: textColor(totalProfitRatio)}">{{ totalProfitRatio }} %</span>
                        </v-row>
                        <v-divider />
                        <v-row class="pa-4 mx-0">
                            <v-col class="pa-2" cols="6">·총매입금액 {{ commaFormat(Math.floor(totalPurchase)) }} 원</v-col>
                            <v-col class="pa-2" cols="6">·총평가금액 {{ commaFormat(Math.floor(totalAsset - results.cash)) }} 원</v-col>
                            <v-col class="pa-2" cols="6">
                                <span>·총평가손익 </span>
                                <span :style="{color: textColor(totalAsset - results.startCash)}">{{ commaFormat(Math.floor(totalAsset - results.cash - totalPurchase)) }} 원</span>
                            </v-col>
                            <v-col class="pa-2" cols="6">·현금 {{ commaFormat(Math.floor(results.cash)) }} 원</v-col>
                        </v-row>
                    </div>

                    <v-divider />

                    <v-col v-for="item in results.stocks" :key="item.code">
                        <stock-item :item="item" @finance="showFinance" @disclosure="showDisclousure" @search="showNaverSearch" @buy="$refs.buyDialog.show(item)" @sell="$refs.sellDialog.show(item)" @price="showPrices(item)" @find="findByCode" />
                    </v-col>
                </v-card>

                <v-card>
                    <div class="pa-3" style="font-size: 20px; font-weight: bold">종목 검색</div>
                    <v-divider />
                    <div class="pa-2">
                        <v-text-field class="my-3" v-model="name" outlined label="이름 혹은 코드로 검색" hide-details />

                        <sector-board class="my-3" ref="sectorBoard" />

                        <condition-board ref="conditionBoard" title="검색" />

                        <div class="text-center my-4">
                            <v-btn @click="firstFind" color="primary">검색하기</v-btn>
                        </div>

                        <v-data-table :headers="headers" :items="searchResult" :items-per-page="3000" :sort-by="sortList" :sort-desc="sortDesc" item-key="name" multi-sort dense hide-default-footer class="elevation-1">
                            <template v-slot:body="{ items }">
                                <tbody>
                                    <tr v-for="item in items" :key="item.code">
                                        <td>
                                            {{ item.name }} ({{ item.code }})
                                        </td>
                                        <td class="text-center" style="font-size: 12px">
                                            {{ sectorData[item.sector] }}
                                        </td>
                                        <td class="text-center" v-for="key in sortList" :key="`${item}-${key}`">
                                            {{ item[key] }}
                                        </td>
                                        <td class="text-center">
                                            <span>{{ commaFormat(item.price) }}</span>
                                            <v-icon class="mx-2" style="cursor: pointer" @click="showPrices(item)" color="primary" v-if="!item.pricesLoading">show_chart</v-icon>
                                            <v-progress-circular size="16" indeterminate color="primary" v-else />
                                        </td>
                                        <td class="text-center" @click="showFinance(item)">
                                            <v-icon style="cursor: pointer" color="primary" v-if="!item.financeLoading">link</v-icon>
                                            <v-progress-circular size="16" indeterminate color="primary" v-else />
                                        </td>
                                        <td class="text-center" @click="showDisclousure(item)">
                                            <v-icon style="cursor: pointer" color="primary">link</v-icon>
                                        </td>
                                        <td class="text-center" @click="showNaverSearch(item)">
                                            <v-icon style="cursor: pointer" color="primary">link</v-icon>
                                        </td>
                                        <td class="text-center" @click="$refs.buyDialog.show(item)">
                                            <v-btn small text color="red">매수</v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-data-table>

                        <v-row class="my-2" justify="center" v-if="!isEnd">
                            <v-btn text @click="moreSearch">더 보기</v-btn>
                        </v-row>
                    </div>
                </v-card>
            </div>
        </v-card>
    </v-container>
    <v-container v-else>
        <v-card class="mt-3">
            <div>
                <v-row class="primary-header pa-3 ma-0" align="center">
                    <span style="font-size: 20px">{{ title }}</span>
                </v-row>
                <v-col>
                    <div class="mb-3" style="font-size: 15px">{{ description }}</div>
                    <div class="mb-3" style="font-size: 12px" v-for="text in texts" :key="text">
                        {{ text }}
                    </div>
                </v-col>
            </div>

            <v-divider />

            <div class="pa-3">
                <v-row align="center">
                    <v-btn class="mx-1" color="primary" small @click="$refs.assetChartDialog.show(results, docRef)">보고서</v-btn>
                    <v-btn class="mx-1" color="primary" small @click="$refs.transactionDialog.show(docRef)">거래 내역</v-btn>
                    <v-spacer />
                    <v-btn color="secondary" small @click="sponsor">개발자 후원하기</v-btn>
                    <v-btn class="mx-1" color="primary" small @click="nextMonth">다음 달</v-btn>
                </v-row>
                <v-row class="mt-3 headline" justify="center">
                    {{ results.date }}
                </v-row>
                <v-card>
                    <div>
                        <v-row class="pa-2 mx-0" align="center">
                            <span style="font-size: 13px; font-weight: bold">총 자산 현황</span>
                            <v-spacer />
                            <span class="px-3" style="font-size: 12px">{{ commaFormat(Math.floor(totalAsset)) }} 원</span>
                            <span :style="{color: textColor(totalProfitRatio)}">{{ totalProfitRatio }} %</span>
                        </v-row>
                        <v-divider />
                        <v-row class="mx-0 my-2" style="font-size: 12px">
                            <v-col class="pa-0" cols="6">
                                <v-row class="pa-0 ma-1" justify="space-between">
                                    <span>·총매입금액</span>
                                    <span>{{ commaFormat(Math.floor(totalPurchase)) }} 원</span>
                                </v-row>
                            </v-col>
                            <v-col class="pa-0" cols="6">
                                <v-row class="pa-0 ma-1" justify="space-between">
                                    <span>·총평가금액</span>
                                    <span>{{ commaFormat(Math.floor(totalAsset - results.cash)) }} 원</span>
                                </v-row>
                            </v-col>
                            <v-col class="pa-0" cols="6">
                                <v-row class="pa-0 ma-1" justify="space-between">
                                    <span>·총평가손익</span>
                                    <span :style="{color: textColor(totalAsset - results.startCash)}">{{ commaFormat(Math.floor(totalAsset - results.cash - totalPurchase)) }} 원</span>
                                </v-row>
                            </v-col>
                            <v-col class="pa-0" cols="6">
                                <v-row class="pa-0 ma-1" justify="space-between">
                                    <span>·현금</span>
                                    <span>{{ commaFormat(Math.floor(results.cash)) }} 원</span>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>

                    <v-divider />

                    <v-col v-for="item in results.stocks" :key="item.code">
                        <stock-item :item="item" @finance="showFinance" @disclosure="showDisclousure" @search="showNaverSearch" @buy="$refs.buyDialog.show(item)" @sell="$refs.sellDialog.show(item)" @price="showPrices(item)" @find="findByCode" />
                    </v-col>
                </v-card>

                <v-card>
                    <div class="pa-3" style="font-size: 20px; font-weight: bold">종목 검색</div>
                    <v-divider />
                    <div class="pa-2">
                        <v-text-field class="my-2" v-model="name" solo label="코드 혹은 이름으로 검색" persistent-hint hint="코드 혹은 이름을 입력 시 다른 조건은 무시됩니다" />

                        <sector-board ref="sectorBoard" />

                        <condition-board ref="conditionBoard" title="검색" />

                        <div class="text-center my-4">
                            <v-btn @click="firstFind" color="primary">검색하기</v-btn>
                        </div>

                        <v-data-table :headers="headers" :items="searchResult" :items-per-page="3000" :sort-by="sortList" :sort-desc="sortDesc" item-key="name" multi-sort fixed-header dense hide-default-footer class="elevation-1">
                            <template v-slot:body="{ items }">
                                <tbody>
                                    <tr v-for="item in items" :key="item.code">
                                        <td>
                                            {{ item.name }}
                                        </td>
                                        <td class="text-center" style="font-size: 12px">
                                            {{ sectorData[item.sector] }}
                                        </td>
                                        <td class="text-center" v-for="key in sortList" :key="`${item}-${key}`">
                                            {{ item[key] }}
                                        </td>
                                        <td class="text-center">
                                            <span>{{ commaFormat(item.price) }}</span>
                                            <v-icon class="mx-2" style="cursor: pointer" @click="showPrices(item)" color="primary" v-if="!item.pricesLoading">show_chart</v-icon>
                                            <v-progress-circular size="16" indeterminate color="primary" v-else />
                                        </td>
                                        <td class="text-center" @click="showFinance(item)">
                                            <v-btn text x-small color="primary" v-if="!item.financeLoading">재무 정보</v-btn>
                                            <v-progress-circular size="16" indeterminate color="primary" v-else />
                                        </td>
                                        <td class="text-center" @click="showDisclousure(item)">
                                            <v-btn text small color="primary" v-if="!item.financeLoading">공시 정보</v-btn>
                                        </td>
                                        <td class="text-center" @click="showNaverSearch(item)">
                                            <v-btn text small color="primary" v-if="!item.financeLoading">뉴스</v-btn>
                                        </td>
                                        <td class="text-center" @click="$refs.buyDialog.show(item)">
                                            <v-btn text color="primary">매수</v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-data-table>

                        <v-row class="my-2" justify="center" v-if="!isEnd">
                            <v-btn text @click="moreSearch">더 보기</v-btn>
                        </v-row>
                    </div>
                </v-card>
            </div>
        </v-card>
    </v-container>
    
    <finance-dialog ref="financeDialog" />

    <prices-dialog ref="pricesDialog" />

    <transaction-dialog ref="transactionDialog" />

    <buy-dialog ref="buyDialog" :cash="results.cash" @buy="buy" />

    <sell-dialog ref="sellDialog" @sell="sell" />

    <asset-chart-dialog ref="assetChartDialog" />
    
    <sponsor-dialog ref="sponsorDialog" />
</div>
</template>

<script>
import firebase, {
    firestore
} from 'firebase/app'
import {
    db,
    auth
} from '@/firebase'
import {
    AccountToast
} from '@/mixins/account-toast.js'
import {
    maxDate,
    sectorData
} from '@/constants'
import StockItem from '@/views/components/StockItem'
import SectorBoard from '@/views/components/SectorBoard'
import ConditionBoard from '@/views/components/ConditionBoard'
import FinanceDialog from '@/views/dialogs/FinanceDialog'
import PricesDialog from '@/views/dialogs/PricesDialog'
import BuyDialog from '@/views/dialogs/BuyDialog'
import SellDialog from '@/views/dialogs/SellDialog'
import TransactionDialog from '@/views/dialogs/TransactionDialog'
import AssetChartDialog from '@/views/dialogs/AssetChartDialog'
import SponsorDialog from '@/views/dialogs/SponsorDialog'

const moment = require("moment")

export default {
    metaInfo: {
        title: "Invest Helper | 모의투자",
        htmlAttrs: {
            lang: "ko-KR"
        },
        meta: [{
                charset: "utf-8"
            },
            {
                name: "description",
                content: "20년치 코스피/코스닥 주식 모의 투자를 통해 투자 실력을 테스트합니다"
            },
            {
                name: "keywords",
                content: "코스피, 코스닥, 모의투자"
            },
        ]
    },
    components: {
        StockItem,
        SectorBoard,
        ConditionBoard,
        FinanceDialog,
        PricesDialog,
        BuyDialog,
        SellDialog,
        TransactionDialog,
        AssetChartDialog,
        SponsorDialog
    },
    mixins: [
        AccountToast
    ],
    data: () => ({
        title: '국내주식 모의투자',
        description: '국내주식 (코스피, 코스닥)을 월단위로 모의투자하여 중장기 투자 전략 및 감각을 검증합니다',
        texts: [
            '1. 주가는 매월 말일 종가 기준',
            '2. 모든 종목의 사업보고서는 결산월에 관계없이 3월에 업데이트됨',
            '3. 모든 행위는 자동저장됩니다',
        ],
        docRef: '',
        results: {},
        isSaved: false,
        loading: false,
        name: '',
        headers: [],
        sortList: [],
        sortDesc: [],
        searchPage: 0,
        isEnd: true,
        searchResult: [],
    }),
    computed: {
        user() {
            return this.$store.getters.user
        },
        sectorData() {
            return sectorData
        },
        buyConditionText() {
            const sorted = this.getSortedBuyConditions().map(x => x.name)
            return sorted.join(' - ')
        },
        totalAsset() {
            if (!this.results.stocks) return 0

            let stockAsset = 0
            for (const code in this.results.stocks) stockAsset += this.results.stocks[code].total * 0.9975
            return this.results.cash + stockAsset
        },
        totalPurchase() {
            if (!this.results.stocks) return 0

            let stockPurchase = 0
            for (const code in this.results.stocks) stockPurchase += this.results.stocks[code].purchase
            return stockPurchase
        },
        totalProfitRatio() {
            return ((this.totalAsset / this.results.startCash - 1) * 100).toFixed(2)
        }
    },
    watch: {
        async user() {
            this.docRef = db.collection('users').doc(this.user.id).collection('simulations').doc(this.$route.params.id)
            this.results = await this.docRef.parseDocument()
        }
    },
    created() {},
    async mounted() {
        if (this.$store.getters.checkActive) {
            this.docRef = db.collection('users').doc(this.user.id).collection('simulations').doc(this.$route.params.id)
            this.results = await this.docRef.parseDocument()
        }
    },
    methods: {
        async findByCode(item) {
            this.name = item.code
            this.firstFind()
        },
        async moreSearch() {
            this.searchPage++
            let data = await this.find()
            this.postProcess(data).forEach(v => this.searchResult.push(v))
        },
        async firstFind() {
            if (!this.$refs.conditionBoard.validate()) return
            
            if (!this.name && !this.$refs.sectorBoard.validate()) return

            this.searchPage = 0
            const data = await this.find()
            this.updateSearchResultTable(data)
        },
        async find() {
            this.loading = true
            const url = this.buildUrl()
            let data = []
            try {
                const result = await this.$http.get(url)
                data = result.data
                this.isEnd = data.length < 20
                
                if (data.length == 0) this.$toasted.info('해당되는 종목이 없습니다')
                else this.$toasted.info('검색이 완료되었습니다')
            } catch (e) {
                this.$toasted.info('검색 도중 오류가 발생했습니다')
                this.$http.post('/report-error', {stack: e.stack})
                return data
            } finally {
                this.loading = false
                return data
            }
        },
        updateSearchResultTable(result) {
            this.updateHeaders()

            this.sortDesc = []
            for (let i = 0; i < this.sortList.length; i++) {
                this.sortDesc.push(this.orderList[i] == 'DESC')
            }

            this.searchResult = this.postProcess(result)
        },
        updateHeaders() {
            this.headers = []

            this.headers.push({
                text: "종 목",
                value: "name",
                sortable: false
            }, {
                text: "업 종",
                value: "sector",
                sortable: false,
                align: "center"
            })

            for (const key of this.sortList) {
                this.headers.push({
                    text: this.$t(key),
                    value: key,
                    align: 'center'
                })
            }

            this.headers.push({
                text: "주 가",
                value: "price",
                sortable: false,
                align: "center"
            }, {
                text: "재무 정보",
                value: "",
                sortable: false,
                align: "center"
            }, {
                text: "공시 정보",
                value: "",
                sortable: false,
                align: "center"
            }, {
                text: "뉴스 검색",
                value: "",
                sortable: false,
                align: "center"
            }, {
                text: "",
                value: "",
                sortable: false,
            })
        },
        async showPrices(item) {
            const code = item.code
            let date = new Date(this.results.date)
            date = new Date(date.getFullYear(), date.getMonth() + 1, 1).toISOString().substring(0, 10)

            if (code == '000000') return

            item.pricesLoading = true
            const url = `/candle?code=${code}&date=${date}`
            const result = await this.$http.get(url)
            item.pricesLoading = false

            this.$refs.pricesDialog.show(result.data)
        },
        async showFinance(item) {
            const code = item.code
            const date = new Date(this.results.date).toISOString().substring(0, 7)

            if (code == '000000') return

            if (item.finance) {
                this.$refs.financeDialog.show(item.finance)
                return
            }

            item.financeLoading = true
            const url = `/finance?code=${code}&date=${date}`
            const result = await this.$http.get(url)
            item.financeLoading = false

            item.finance = result.data
            this.$refs.financeDialog.show(item.finance)
        },
        showDisclousure(item) {
            const date = this.results.date
            const startDate = moment(date).subtract(1, 'year').endOf('month').format("YYYY.MM.DD")
            const endDate = moment(date).endOf('month').format("YYYY.MM.DD")

            window.open(`http://dart.fss.or.kr/dsab001/main.do?autoSearch=true&textCrpNm=${item.code}&startDate=${startDate.replace(/\./gi, "")}&endDate=${endDate.replace(/\./gi, "")}`, "_blank")
        },
        showNaverSearch(item) {
            const date = this.results.date
            const startDate = moment(date).subtract(1, 'year').endOf('month').format("YYYY.MM.DD")
            const endDate = moment(date).endOf('month').format("YYYY.MM.DD")

            window.open(`https://search.naver.com/search.naver?&where=news&query=${item.name}&ds=${startDate}&de=${endDate}&docid=&nso=so:r,p:from${startDate.replace(/\./gi, "")}to${endDate.replace(/\./gi, "")},a:all`, "_blank")
        },
        async buy(data) {
            let stockData = this.results.stocks[data.code]

            if (stockData) {
                stockData.purchase += data.total
                stockData.total += data.total
                stockData.count += data.count
                stockData.price = data.price
                this.$set(this.results.stocks, data.code, stockData)
            } else {
                stockData = data
                stockData.purchase = data.total
                stockData.price = data.price
                this.$set(this.results.stocks, data.code, stockData)
            }

            this.results.cash -= data.total

            this.docRef.update({
                cash: this.results.cash,
                [`stocks.${data.code}`]: stockData
            })

            this.docRef.collection('records').add({
                sort: 'buy',
                createdAt: Date.now(),
                date: this.results.date,
                code: data.code,
                name: data.name,
                count: data.count,
                price: data.price,
                total: data.total
            })
        },
        sell(data) {
            const stockData = this.results.stocks[data.code]

            if (!stockData) return

            stockData.purchase -= Math.round(stockData.purchase / stockData.count * data.count)
            stockData.total -= data.total
            stockData.count -= data.count
            this.$set(this.results.stocks, data.code, stockData)

            this.results.cash += data.total * 0.9975

            if (stockData.count > 0) {
                this.docRef.update({
                    cash: this.results.cash,
                    [`stocks.${data.code}`]: stockData
                })
            } else {
                delete this.results.stocks[data.code]
                this.docRef.update({
                    cash: this.results.cash,
                    [`stocks.${data.code}`]: firebase.firestore.FieldValue.delete()
                })
            }

            this.docRef.collection('records').add({
                sort: 'sell',
                createdAt: Date.now(),
                date: this.results.date,
                code: data.code,
                name: data.name,
                count: data.count,
                price: data.price,
                total: data.total
            })
        },
        async nextMonth() {
            this.searchResult = []
            this.isEnd = true

            const currentMonth = parseInt(this.results.date.substring(5, 7))
            const plusYear = Math.floor(currentMonth / 12)

            const year = parseInt(this.results.date.substring(0, 4)) + plusYear
            const month = plusYear > 0 ? 1 : currentMonth + 1
            const codes = Object.keys(this.results.stocks).join(',')

            const today = moment(`${year}-${month}-01`)
            if (today.isSameOrAfter(maxDate)) return this.$toasted.error(`${maxDate.year()}년 ${maxDate.month() + 1}월 이전까지만 진행가능합니다`)

            try {
                this.loading = true
                const result = await this.$http.get('/simulation/next', {
                    params: {
                        year,
                        month,
                        codes
                    }
                })

                const batch = db.batch()

                const newSnapshotRef = this.docRef.collection('snapshots').doc()
                batch.set(newSnapshotRef, {
                    date: this.results.date,
                    cash: this.results.cash,
                    stocks: this.results.stocks
                })

                for (const code in this.results.stocks) {
                    const stock = this.results.stocks[code]

                    if (result.data.map(v => v.code).includes(code)) {
                        const newData = result.data.find(v => v.code == code)
                        stock.total = Math.round(stock.total * newData.price / stock.price)
                        stock.price = newData.price
                        this.$set(this.results.stocks, code, stock)

                        batch.update(this.docRef, {
                            [`stocks.${code}.price`]: stock.price,
                            [`stocks.${code}.total`]: stock.total
                        })
                    } else {
                        this.sell(Object.assign({}, stock))
                        this.$toasted.info(`${stock.name} (${stock.code})가 거래정지 등의 이유로 전량 매도되었습니다`)
                    }
                }

                const newDate = new Date(year, month).toISOString().substring(0, 7)
                batch.update(this.docRef, {
                    date: newDate,
                    cash: this.results.cash,
                })

                await batch.commit()

                this.results.date = newDate

                this.$toasted.success('다음 달로 진행되었습니다')
            } catch (e) {
                this.$toasted.error('오류가 발생했습니다. 관리자에게 문의하세요')
                this.$http.post('/report-error', {stack: e.stack})
            } finally {
                this.loading = false
            }
        },
        buildUrl() {
            const year = this.results.date.substring(0, 4)
            const month = this.results.date.substring(5, 7)

            let url = `/simulation/find?year=${year}&month=${month}&page=${this.searchPage}&text=${this.name}&`

            let sort = ''
            let order = ''
            for (let item of this.$refs.conditionBoard.sortedConditions) {
                const min = Math.min(item.value[0], item.value[1])
                const max = Math.max(item.value[0], item.value[1])
                url += `${item.id}Min=${min.toFixed(1)}&${item.id}Max=${max.toFixed(1)}&`
                sort += `${item.id},`
                order += `${item.order},`
            }

            sort = sort.substring(0, sort.length - 1)
            order = order.substring(0, order.length - 1)
            this.sortList = sort.split(',')
            this.orderList = order.split(',')

            url += `sort=${sort}&order=${order}&market=${this.$refs.sectorBoard.activeMarketIdsText}&sector=${this.$refs.sectorBoard.activeSectorIdsText}`

            return url
        },
        postProcess(data) {
            return data.map(v => {
                v.financeLoading = false
                v.pricesLoading = false
                return v
            })
        },
        commaFormat(value) {
            if (!value) return 0
            return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        textColor(value) {
            if (value > 0) return 'red'
            else if (value < 0) return 'blue'
            else return 'black'
        },
        sponsor() {
            if (this.$store.state.mobile) window.open('https://qr.kakaopay.com/2810060111039909710072079c402115')
            else this.$refs.sponsorDialog.show()
        }
    },
}
</script>
